import React from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./kioskBookingDetailsCard.scss";
import "./kioskSelectPlayer.scss";
import { ICustomer } from "redux/reducers/models/customer";
import { IBooking } from "redux/reducers/models/teetime";
import { convertTime } from "helpers/Helpers";
import moment from "moment";
import { faGolfFlagHole } from "@fortawesome/pro-regular-svg-icons";

interface IKioskBookingDetailsCardProps {
  booking: IBooking | null;
  customer: Partial<ICustomer> | null;
  searchType: string;
  setCustomer?: (customer: Partial<ICustomer> | null) => void;
}

export function KioskBookingDetailsCard({ booking, customer }: IKioskBookingDetailsCardProps) {
  const { t } = useTranslation();

  if (!booking) {
    return null;
  }

  const timePeriod = booking?.tee_time?.start_time ? moment(booking?.tee_time?.start_time, "HH:mm:ss").format("A") : "";

  return (
    <div className="ui-kiosk-details-card">
      <div className="ui-kiosk-details-row items-center">
        <span className="ui-kiosk-details-label">{t("Tee time")}</span>
        <span className="ui-kiosk-details-value_teetime">
          {convertTime(booking?.tee_time?.start_time, true)}
          <span className="ui-kiosk-details-value_teetime_time">{timePeriod}</span>
        </span>
      </div>

      <hr />

      <div className="ui-kiosk-details-row items-center">
        <p className="ui-kiosk-details-label">{t("Player name")}</p>
        <div className="ui-kiosk-details-value flex items-center gap-2">
          <div className="ui-kiosk-select-player-pill-avatar">
            <span className="ui-kiosk-select-player-pill-initials">
              {customer?.full_name
                ? customer.full_name
                    .split(" ")
                    .filter(part => part.length > 0)
                    .slice(0, 2)
                    .map(part => part[0])
                    .join("")
                : ""}
            </span>
          </div>
          <span>{customer?.full_name}</span>
        </div>
      </div>

      <hr />
      <div className="ui-kiosk-details-row items-flex-start">
        <span className="ui-kiosk-details-label">{t("Items included")}</span>

        <div className="flex flex-col items-end gap-2">
          <p className="ui-kiosk-details-value">
            <FontAwesomeIcon icon={faGolfFlagHole} className="ui-kiosk-details-value_icon" />{" "}
            <span className="ml-2">
              {booking?.holes} {t("Holes")}
            </span>
          </p>
        </div>
      </div>
    </div>
  );
}
